var modVideo = function(){
    var scope = ".js-mod-video";
    ui.ready(
        scope,
        function($mod){
            $mod.find(scope+"__video-img").click(
                function(){
                    var $vid = $mod.find(scope+"__video");
                    var url = $vid.data("video-url");
                    $vid.html('<iframe width="560" height="315" src="'+url+'" frameborder="0" allowfullscreen></iframe>');
                }
            );
        }
    );
}();
